import styled from '@emotion/styled'
import { CircularProgress } from '@mui/material'
import { useEffect, useState } from 'react'

interface Props {
   timeoutAmount: number
   onTimeout: () => void
   timeoutStart: boolean
   className?: string
   color?: 'primary' | 'secondary' | 'warning' | 'error' | 'info' | 'success'
}

const CountDownSpinner: React.FC<Props> = ({
   onTimeout,
   timeoutAmount,
   timeoutStart,
   className,
   color,
}) => {
   const [timeLeft, setTimeLeft] = useState(timeoutAmount * 100)

   useEffect(() => {
      if (timeoutStart) {
         const timer = setTimeout(() => {
            setTimeLeft(timeLeft - 10)
         }, 100)
         if (timeLeft === 0) {
            onTimeout()
            clearTimeout(timer)
         }
         return () => clearTimeout(timer)
      }
   }, [timeLeft, timeoutStart])

   return (
      <Holder className={`count-down-timer ${className}`}>
         <CircularProgress
            variant="determinate"
            value={timeLeft / timeoutAmount}
            size={60}
            thickness={5}
            color={color || 'secondary'}
            className="count-down-timer__progress"
         />
         <span className="count-down-timer__number">{(timeLeft / 100).toFixed(0)}</span>
      </Holder>
   )
}

const Holder = styled.div`
   position: relative;
   display: flex;
   align-items: center;
   justify-content: center;
   background-color: #eaeaea;
   border-radius: 50%;

   .count-down-timer__number {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 1em;
      color: #424242;
      background-color: #6060606c;
      width: 2em;
      height: 2em;
      padding: 0.3em;
      border-radius: 50%;
      line-height: 2;
      text-align: center;
      /* margin-left: 0.5em; */
   }

   .count-down-timer__progress {
   }
`

export type { Props }
export default CountDownSpinner
